<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec" id="main">
    <div class="container">
      <div class="flex-bet-main mb-2">
        <div class="side-heading">
          <h6>{{ $t('moreAboutSaqf.title') }}</h6>
          <p class="font13 gray-col">{{ $t('moreAboutSaqf.subtitle') }}</p>
        </div>
      </div>
      <div class="manage-account-tabs">
        <ul class="nav nav-tabs mb-3" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="firstTap"
              data-bs-toggle="tab"
              data-bs-target="#firstTapcontent"
              type="button"
              role="tab"
              aria-controls="firstTapcontent"
              aria-selected="true"
            >
              {{ $t('moreAboutSaqf.aboutSaqf') }}
            </button>
          </li>
          <li class="nav-item" @click="GetFaqs" role="presentation">
            <button
              class="nav-link"
              id="secondTap"
              data-bs-toggle="tab"
              data-bs-target="#secondTapcontent"
              type="button"
              role="tab"
              aria-controls="secondTapcontent"
              aria-selected="false"
            >
              {{ $t('moreAboutSaqf.frequentQuestions') }}
            </button>
          </li>
          <li class="nav-item" @click="GetTerms" role="presentation">
            <button
              class="nav-link"
              id="thirdTap"
              data-bs-toggle="tab"
              data-bs-target="#thirdTapcontent"
              type="button"
              role="tab"
              aria-controls="thirdTapcontent"
              aria-selected="false"
            >
              {{ $t('moreAboutSaqf.termsAndConditions') }}
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <!--عن سقف-->
          <div
            class="tab-pane fade show active"
            id="firstTapcontent"
            role="tabpanel"
            aria-labelledby="firstTapcontent-tab"
          >
            <div class="more-box">
              <p
                class="main-p font15 gray-col"
                v-if="!loader"
                v-html="whoUsText"
              ></p>
              <div class="loader-text" v-else>
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="80%" class="mb-2"></Skeleton>
                <Skeleton width="60%" class="mb-2"></Skeleton>
              </div>
            </div>
          </div>
          <!--الاسئلة المتكررة-->
          <div
            class="tab-pane fade"
            id="secondTapcontent"
            role="tabpanel"
            aria-labelledby="secondTapcontent-tab"
          >
            <div v-if="!loader">
              <div class="accordion" v-if="Faqs.length" id="accordionExample">
                <div
                  class="accordion-item mb-3"
                  v-for="(faq, i) in Faqs"
                  :key="faq.id"
                >
                  <h2 class="accordion-header" :id="'heading' + i">
                    <button
                      class="accordion-button font-bold black"
                      :class="{ collapsed: i != 0 }"
                      type="button"
                      data-bs-toggle="collapse"
                      :data-bs-target="'#collapse' + i"
                      :aria-expanded="{ true: i == 0 }"
                      :aria-controls="'collapse' + i"
                    >
                      {{ faq.question }}
                    </button>
                  </h2>
                  <div
                    :id="'collapse' + i"
                    class="accordion-collapse collapse"
                    :class="{ show: i == 0 }"
                    :aria-labelledby="'heading' + i"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body gray-col font15">
                      {{ faq.answer }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="no-data-div">
                <div class="no-data-table">
                  <img :src="noDataImg" alt="" />
                  <div>{{ $t('moreAboutSaqf.noDataToDisplay') }}</div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="bg-white-div">

                <Skeleton width="100%" height="70px" class="mb-2"></Skeleton>
                <Skeleton width="100%" height="70px" class="mb-2"></Skeleton>
              </div>
            </div>
          </div>
          <!--الشروط والاحكام-->
          <div
            class="tab-pane fade"
            id="thirdTapcontent"
            role="tabpanel"
            aria-labelledby="thirdTapcontent-tab"
          >
            <div class="more-box">
              <p
                class="main-p font15 gray-col"
                v-if="!loader"
                v-html="termsText"
              ></p>
              <div class="loader-text" v-else>
                <Skeleton width="100%" class="mb-2"></Skeleton>
                <Skeleton width="80%" class="mb-2"></Skeleton>
                <Skeleton width="60%" class="mb-2"></Skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { ref, onMounted } from "vue";

// reactive state
const whoUsText = ref("");
const termsText = ref("");
const loader = ref(false);
const noDataImg = ref(require("@/assets/imgs/7486744.png"));

const Faqs = ref([]);

// functions
function whoUs() {
  loader.value = true;
  axios
    .get("/manager/about", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      whoUsText.value = response.data.data;
      loader.value = false;
    });
}
function GetTerms() {
  loader.value = true;
  axios
    .get("/manager/terms", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      termsText.value = response.data.data;
      loader.value = false;
    });
}
function GetFaqs() {
  loader.value = true;
  axios
    .get("/manager/fqss", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      Faqs.value = response.data.data;
      loader.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  whoUs();
});
</script>
